import size from 'lodash/size';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import pick from 'lodash/pick';
import cn from 'classnames';
import css from './css.css';

import { getDialogModelId, getField, getItemId, getValueAdaptData, getValueAdaptSources, getActionPermissions, getAutocompleteOptions, getEditFieldValues } from '~/stateGetter';
import { mergeField, presentConstraintValues, reduceFieldSources, evalDisableConditions, presentFieldConditionSources, } from '~/statePresenter';

import identify from '~/identify';
import { connect } from '~/redux/connect';
import { compareKeys } from 'mythil/object';
import { fetchFieldOptions } from '~/rx/model/fieldOptions';
import { modelActionsCreator } from '~/actions/model_actions';


let emptyObject = {};

const _areStatePropsEqual = (prev, curr) => {
    return compareKeys(prev, curr, {
        compareFoo: (a, b, key) => {
            switch (key) {
                case 'valueAdaptSources':
                    return isEqual(a, b);
                case 'constraintValues':
                    return isEqual(a, b);
                default:
                    return a === b;
            }
        },
    });
};

const areStatePropsEqual = (prev, curr) => {
    let isEqual = _areStatePropsEqual(prev, curr);

    if (!isEqual) {
        // console.log('VARIADIC FIELD areStatePropsEqual "'+curr.field.name+'"  PERF', diffKeys(prev, curr));
    }

    return isEqual;
};

// TODO: think of concept where you can avoid this mess
export const connectedField = connect(
    (state, { modelId, name, inputType, view, ...others }) => {
        let fieldData = others.fieldData || getField(state, modelId, inputType, name),
            small = getDialogModelId(state) === modelId;

        let props = {
            ...fieldData,
            // modelTitle: fieldData.field.model ? getModelTitle(state, fieldData.field.model) : null,
            itemId: getItemId(state, modelId),
            small,
            canCreateRecords: inputType === identify.EDITFIELD && getActionPermissions(state, modelId).create,
            canUpdateRecords: inputType === identify.EDITFIELD && getActionPermissions(state, modelId).update,

        };

        props = { ...props, ...getValueAdaptData(state, modelId) };

        const hasDisableConditions = !isEmpty(fieldData.field.disableConditions) && inputType === identify.EDITFIELD;

        if (hasDisableConditions || fieldData.field.adaptValue || size(fieldData.field.constraints)) {
            props.valueAdaptSources = getValueAdaptSources(state, modelId);
            props.valueAdaptSources = reduceFieldSources(
                fieldData.field,
                props.editFields,
                props.filters,
                props.valueAdaptSources
            );
        }
        
        if (hasDisableConditions)  {
            let { valueKeys, optionKeys } = presentFieldConditionSources(props.editFields);
            let conditionValues = pick(getEditFieldValues(state, modelId), valueKeys);
            let conditionAutocompletes = pick(getAutocompleteOptions(state, modelId, identify.EDITFIELD), optionKeys);
            props.isInputDisabled = evalDisableConditions({
                view,
                itemId: props.itemId,
                disableConditions: fieldData.field.disableConditions,
                editFieldValues: {
                    ...props.valueAdaptSources.editFieldValues,
                    ...conditionValues
                },
                editFieldOptions: {
                    ...props.valueAdaptSources.editFieldOptions,
                    ...conditionAutocompletes,
                }
            });
        }

        return props;
    },
    (dispatch, { modelId, name, inputType }) => {
        const modelActions = modelActionsCreator(modelId);

        return {
            dispatch,
            onChange: (value, filterType = '') =>
                dispatch(modelActions.changeFieldValue(name, inputType, value, { filterType })),

            onQueryChange: (query) => dispatch(modelActions.changeFieldQuery(name, inputType, query)),

            onAddRelationRecord: () => dispatch(modelActionsCreator(modelId).setRelationshipField(name, inputType)),

            onEditRelationRecord: (id) => dispatch(modelActionsCreator(modelId).setRelationshipField(name, inputType, id))
        };
    },
    (
        { className, field, valueAdaptSources, validationMessage, canCreateRecords, canUpdateRecords, isInputDisabled, ...other },
        { dispatch, onAddRelationRecord, onEditRelationRecord, ...otherActions },
        { modelId, view, inputType, ...ownProps }
    ) => {
        className = cn(className, { [css.validationError]: !!validationMessage });

        let mergeData = { field, ...other, ...valueAdaptSources };

        let constraintValues = emptyObject;
        if (size(field.constraints)) {
            constraintValues = presentConstraintValues(field.inputType, field.constraints, {
                ...other,
                ...valueAdaptSources,
            });
        }
        let fieldData = {
            inputType,
            ...ownProps,
            modelId,
            constraintValues,
            ...other,
            ...otherActions,
            ...mergeField(mergeData),
            onChange: ownProps.onChange || otherActions.onChange,
            requestGroup: field.isAutocomplete
                ? identify.modelFieldRequestGroup(modelId, field.inputType, field.name)
                : undefined,
            isinvalid: !!validationMessage?.length,
            isReadonly: view === identify.VIEW_VIEW || isInputDisabled || ownProps.isReadonly || !field.editable || field.disableInput,
            title: ownProps.title ?? field.title,
            validationMessage: validationMessage?.length ? validationMessage : null,
            className,
            onAddRelationRecord: canCreateRecords && field.canCreate ? onAddRelationRecord : null,
            onEditRelationRecord: canUpdateRecords && field.canCreate ? onEditRelationRecord : null,
            fetchOptions: (query, selectedItems) => {
                return dispatch(
                    fetchFieldOptions(modelId, field.inputType, {
                        field: field.name,
                        selectedItems: selectedItems,
                        page: 1,
                        term: query,
                    })
                );
            },
        };

        return fieldData;
    },
    { areStatePropsEqual, forwardRef: true }
);
